import { PhoneIcon } from 'de-suite-me-ui'

export default PhoneIcon
